import React, { useState } from "react";
import styles from "./Form.module.css";
let currentSavingOut = 1000;
let yearlySavingOut = 1200;
let interestOut = 7;
let durationOut = 10;
function Form(props) {
  const [currentSaving, setCurrentSaving] = useState(currentSavingOut);
  const [yearlySaving, setYearlySaving] = useState(yearlySavingOut);
  const [interest, setInterest] = useState(interestOut);
  const [duration, setDuration] = useState(durationOut);

  let data = {};
  function currentSavingHandler(e) {
    setCurrentSaving(e.target.value);
  }
  function yearlySavingHandler(e) {
    setYearlySaving(e.target.value);
  }
  function interestHandler(e) {
    setInterest(e.target.value);
  }
  function durationHandler(e) {
    setDuration(e.target.value);
  }

  const submitHanlder = (e) => {
    e.preventDefault();
    data = {
      currentSavings: currentSaving,
      yearlyContribution: yearlySaving,
      expectedReturn: interest,
      duration,
    };
    props.onHandleSubmit(data);
  };

  const resetHandler = () => {
    setCurrentSaving(currentSavingOut);
    setYearlySaving(yearlySavingOut);
    setInterest(interestOut);
    setDuration(durationOut);
    props.onHandleSubmit(data);
  };

  return (
    <div>
      <form onSubmit={submitHanlder} className={styles.form}>
        <div className={styles["input-group"]}>
          <p>
            <label htmlFor="current-savings">Current Savings ($)</label>
            <input
              type="number"
              id="current-savings"
              onChange={currentSavingHandler}
              value={currentSaving}
              required
            />
          </p>
          <p>
            <label htmlFor="yearly-contribution">Yearly Savings ($)</label>
            <input
              type="number"
              id="yearly-contribution"
              onChange={yearlySavingHandler}
              value={yearlySaving}
              required
            />
          </p>
        </div>
        <div className={styles["input-group"]}>
          <p>
            <label htmlFor="expected-return">
              Expected Interest (%, per year)
            </label>
            <input
              type="number"
              id="expected-return"
              onChange={interestHandler}
              value={interest}
              required
            />
          </p>
          <p>
            <label htmlFor="duration">Investment Duration (years)</label>
            <input
              type="number"
              id="duration"
              onChange={durationHandler}
              value={duration}
              required
            />
          </p>
        </div>
        <p className={styles.actions}>
          <button
            type="reset"
            onClick={resetHandler}
            className={styles.buttonAlt}
          >
            Reset
          </button>
          <button type="submit" className={styles.button}>
            Calculate
          </button>
        </p>
      </form>
    </div>
  );
}

export default Form;
